import compareVersions from "compare-versions";
import ServerDataProvider from "../providers/ServerDataProvider";
import appConfig from "../appconfig";

export default async function(store) {
	const mobileApi = appConfig.mobile.mobileApi();

	if (appConfig.mobile.isMobileApp()) {
		const {version} = await appConfig.getAppInfo();
		const platform = mobileApi.platformId;

		const useApiCdn = store && store.getters && store.getters.featureToggles && store.getters.featureToggles.useApiCdnCaching;
		const serverData = await ServerDataProvider.getServerData(useApiCdn);

		return compareVersions(serverData.tenantSettings.minimumMobileVersion[platform], version) > 0;
	}
	return false;
}
